<script lang="ts">
	import { Dialog as DialogPrimitive } from 'bits-ui'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: DialogPrimitive.OverlayProps = $props()
</script>

<DialogPrimitive.Overlay
	class={cn(
		'data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0 fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs',
		className
	)}
	data-slot="dialog-overlay"
	bind:ref
	{...restProps}
/>
